'use client';
import { Highlight } from '@curology/ui-components-web/react';
import { Button } from '@curology/ui-components-web/react/Button';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useMemo, useState } from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { useVisitContext } from '@/services/visitsService/hooks/useVisitContext';

import BirthdateInput from './components/birthdateInput';
import StateInput from './components/stateInput';
import TermsAndConditions from './components/termsAndConditions';
import { useVisitEligibilityForm } from './hooks/useVisitEligibilityForm';
import { EligibilityFormSchema } from './utils/validation';

const VisitEligibilityForm = () => {
  const { visit } = useVisitContext();
  const [form, setForm] = useState({
    state: visit?.sessionBag.eligibility?.state || '',
    birthdate: visit?.sessionBag.eligibility?.birthdate || '',
    hasAcceptedTerms: false,
  });

  const { treatmentCategory, brand } = useFlowContext();

  const { submit, processing, errors } = useVisitEligibilityForm();

  const valid = useMemo(() => {
    return EligibilityFormSchema.safeParse(form).success;
  }, [form]);

  const setData = (data: Partial<typeof form>) => {
    setForm((prev) => ({ ...prev, ...data }));
  };

  return (
    <form className="data-hj-suppress" onSubmit={submit}>
      {errors?.formErrors && errors.formErrors.length > 0 && (
        <Highlight
          state="critical"
          title={
            <Typography>There was an error with your submission.</Typography>
          }
        >
          {errors?.formErrors.map((error) => (
            <Typography key={error} size="meta">
              {error}
            </Typography>
          ))}
        </Highlight>
      )}
      <StateInput
        birthdate={form.birthdate}
        setState={(state) => setData({ state })}
        state={form.state}
        brand={brand}
        treatmentCategory={treatmentCategory}
      />

      <BirthdateInput
        birthdate={form.birthdate}
        setBirthdate={(birthdate) => setData({ birthdate })}
        state={form.state}
        brand={brand}
        treatmentCategory={treatmentCategory}
      />
      <TermsAndConditions
        brand={brand}
        hasAcceptedTerms={form.hasAcceptedTerms}
        setHasAcceptedTerms={(hasAcceptedTerms) =>
          setData({ hasAcceptedTerms })
        }
        withTosCheckbox={true}
      />
      <Button
        type="submit"
        className="cur-mt-3 cur-w-full"
        loading={processing}
        disabled={processing || !valid}
      >
        Continue
      </Button>
    </form>
  );
};

export default VisitEligibilityForm;
